import { SimpleSlider, FluidSlider } from '../../__utils/sliders';
import GalleryLightbox from '../../__page/lightboxGallery';

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        SimpleSlider.init();
        FluidSlider.init();
        GalleryLightbox.init();
    },
    loaded() {},
    resized() {
        GalleryLightbox.refreshSlider();
    },
    scrolled() {},
    keyDown(e) {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
